import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { formatCents, formatInheritedCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useResourceContext } from 'react-admin';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { codeToField, deriveInheritedRatePreview } from '../rateController/rateControllerModel';
import { RateFieldCheckbox } from './RateFieldCheckbox';
import { useRecordValueReader } from 'resources/rate_settings/utils/fieldsVisibility';
import { useClearRateOnBlank } from '../rateController/useClearRateOnBlank';

type Props = { source: string; inheritedSettings?: any };

export const ChargeRateCentsInput = ({ source, inheritedSettings = {} }: Props) => {
  const resource = useResourceContext();
  const recordValue = useRecordValueReader();

  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Location Rate' : '8hr Charge Rate';

  const clearBaseLocationRate = useClearRateOnBlank('baseChargeRate', source);

  // Location subtext is static: parent base × LT modifier × markups, structure-agnostic.
  const helperText = isLocationLevel
    ? formatCents(
        deriveInheritedRatePreview({
          inherited: inheritedSettings,
          source,
          isLocationLevel,
        }).chargeRate,
      )
    : formatInheritedCents(inheritedSettings, 'charge_rate_cents');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={codeToField('chargeRate', source, recordValue)}
        label={label}
        disabled={!isControlled('chargeRate')}
        sx={{ flex: 1 }}
        helperText={helperText}
        onChange={clearBaseLocationRate}
      />
      <RateFieldCheckbox code="chargeRate" label="Admin controls Location Rate" />
    </Box>
  );
};
